import type { AnimationPreset } from "../js/simulador/video/take-types"

// Preset padrão: os 7 shots cinematográficos convertidos do script original
// (camera-animation.js) para dados editáveis. Os efeitos de luz que antes
// estavam em callbacks onUpdate/onStart agora são parâmetros.
export const DEFAULT_PRESET: AnimationPreset = {
  name: "Cinematic Reveal",
  version: 1,
  fadeColor: "#000000",
  fadeDuration: 0.5,
  takes: [
    {
      id: "take-1",
      name: "Intro Silhueta",
      startTime: 0,
      endTime: 6,
      easing: "easeInOut",
      camera: {
        start: { position: { x: 0, y: 1.2, z: 1.5 }, lookAt: { x: 0, y: 1.1, z: 0 } },
        end: { position: { x: 0.5, y: 1.2, z: 1.3 }, lookAt: { x: 0, y: 1.1, z: 0 } },
        fovStart: 50,
        fovEnd: 45,
      },
      lighting: {
        intensity: 0.4,
        color: "#3b6dd6",
        exposure: 0.5,
        ambientIntensity: 0.15,
        blink: { enabled: false, startOffset: 0, duration: 0, interval: 0.05 },
      },
      fadeIn: false,
    },
    {
      id: "take-2",
      name: "Hero Front",
      startTime: 6,
      endTime: 12,
      easing: "easeInOut",
      camera: {
        start: { position: { x: 1, y: 1, z: 1.8 }, lookAt: { x: 0, y: 1.2, z: 0 } },
        end: { position: { x: 0, y: 1, z: 1.8 }, lookAt: { x: 0, y: 1.2, z: 0 } },
        fovStart: 45,
        fovEnd: 40,
      },
      lighting: {
        intensity: 1,
        color: "#ffffff",
        exposure: 1,
        ambientIntensity: 0.4,
        blink: { enabled: false, startOffset: 0, duration: 0, interval: 0.05 },
      },
      fadeIn: true,
    },
    {
      id: "take-3",
      name: "Close Ombro",
      startTime: 12,
      endTime: 18,
      easing: "linear",
      camera: {
        start: { position: { x: 0.8, y: 1.5, z: -0.3 }, lookAt: { x: 0, y: 1.6, z: 0 } },
        end: { position: { x: 0.8, y: 1.5, z: 0 }, lookAt: { x: 0, y: 1.6, z: 0 } },
        fovStart: 35,
        fovEnd: 32,
      },
      lighting: {
        intensity: 1.2,
        color: "#ffffff",
        exposure: 1,
        ambientIntensity: 0.4,
        blink: { enabled: false, startOffset: 0, duration: 0, interval: 0.05 },
      },
      fadeIn: true,
    },
    {
      id: "take-4",
      name: "Close Peito Logo",
      startTime: 18,
      endTime: 24,
      easing: "easeInOut",
      camera: {
        start: { position: { x: 0.2, y: 1.45, z: 0.8 }, lookAt: { x: 0.1, y: 1.45, z: 0 } },
        end: { position: { x: -0.2, y: 1.45, z: 0.9 }, lookAt: { x: 0.1, y: 1.45, z: 0 } },
        fovStart: 30,
        fovEnd: 28,
      },
      lighting: {
        intensity: 1.3,
        color: "#ffffff",
        exposure: 1.1,
        ambientIntensity: 0.4,
        blink: { enabled: false, startOffset: 0, duration: 0, interval: 0.05 },
      },
      fadeIn: true,
    },
    {
      id: "take-5",
      name: "Costas Numero",
      startTime: 24,
      endTime: 30,
      easing: "easeInOut",
      camera: {
        start: { position: { x: -0.8, y: 1.3, z: -1.5 }, lookAt: { x: 0, y: 1.3, z: 0 } },
        end: { position: { x: 0.8, y: 1.3, z: -1.5 }, lookAt: { x: 0, y: 1.3, z: 0 } },
        fovStart: 40,
        fovEnd: 40,
      },
      lighting: {
        intensity: 1.4,
        color: "#ffffff",
        exposure: 1.1,
        ambientIntensity: 0.4,
        blink: { enabled: true, startOffset: 2, duration: 2, interval: 0.05 },
      },
      fadeIn: true,
    },
    {
      id: "take-6",
      name: "Hero Reset",
      startTime: 30,
      endTime: 36,
      easing: "easeInOut",
      camera: {
        start: { position: { x: 0, y: 2, z: 1 }, lookAt: { x: 0, y: 2, z: 0 } },
        end: { position: { x: 0, y: 1.2, z: 2.1 }, lookAt: { x: 0, y: 1.2, z: 0 } },
        fovStart: 38,
        fovEnd: 42,
      },
      lighting: {
        intensity: 1.2,
        color: "#ffffff",
        exposure: 1,
        ambientIntensity: 0.5,
        blink: { enabled: true, startOffset: 1, duration: 2, interval: 0.05 },
      },
      fadeIn: true,
    },
    {
      id: "take-7",
      name: "Outro Logo",
      startTime: 36,
      endTime: 42,
      easing: "linear",
      camera: {
        start: { position: { x: 0, y: 1.15, z: 3.8 }, lookAt: { x: 0, y: 1.1, z: 0 } },
        end: { position: { x: 0, y: 1.15, z: 3.8 }, lookAt: { x: 0, y: 1.1, z: 0 } },
        fovStart: 45,
        fovEnd: 45,
      },
      lighting: {
        intensity: 0.2,
        color: "#3b6dd6",
        exposure: 0.6,
        ambientIntensity: 0.1,
        blink: { enabled: false, startOffset: 0, duration: 0, interval: 0.05 },
      },
      fadeIn: true,
    },
  ],
}
